<template>
    <div class="body-width divcss5">
      <div>
        <div class="div-row div-bottom news-Medium-24">
            重庆交通大学党委书记宫辉一行来海事大学调研交流并参观大连海大智龙科技有限公司
          <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
        </div>
        <div class="div-text-left news-Regular-14b6">
          <span>2024-07-10</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
        </div>
        <div class="div-line  divcss5"></div>
    
        <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin ">
              <img src="../../../assets/images/news28/1.png" />
            </div>
          </div>
        </div>

        <div class="div-row div-bottom10">
          <p class="indentation">
            7月9日，重庆交通大学党委书记宫辉、副校长黄承锋一行来校调研。党委书记许民强、副校长赵宝刚在综合楼822会议室会见宫辉一行并进行座谈交流。 传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
          </p>
        </div>
        
        <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin ">
              <img src="../../../assets/images/news28/2.png" />
            </div>
          </div>
        </div>
        
        <div class="div-row div-bottom10">
          <p class="indentation">
            许民强代表学校对宫辉一行的到来表示热烈欢迎，他简要介绍了学校的发展历程并表示，重庆交通大学与海大根脉相连、使命相通，希望两校以本次调研交流为新起点，携手并肩，扎实推进各领域务实合作，共同为加快建设交通强国贡献力量。 传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
          </p>
        </div>

        <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin ">
              <img src="../../../assets/images/news28/3.png" />
            </div>
          </div>
        </div>

        <div class="div-row div-bottom10">
            <p class="indentation">
                宫辉向学校的热情接待表示感谢，他介绍了重庆交通大学的基本情况并表示，重庆交通大学地处西南，却与海大同根同源。着眼国家科技发展的战略需求，重庆交通大学期待与海大在综合交通、多式联运等领域开展务实合作，共同提升学科建设水平，努力为交通运输事业发展作出新贡献。 传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
            </p>
            <p class="indentation">
                随后，双方围绕水路交通控制全国重点实验室等平台建设、学科与专业建设、人才队伍以及学生管理情况等内容开展交流座谈。
            </p>
          </div>
        
        <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin ">
              <img src="../../../assets/images/news28/4.png" />
            </div>
          </div>
        </div>
    <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin ">
              <img src="../../../assets/images/news28/5.png" />
            </div>
          </div>
        </div>
         
    <div class="div-row div-bottom10">
          <p class="indentation">
            座谈会后，宫辉一行在赵宝刚的陪同下现场考察了大连海大智龙科技有限公司、大连东北亚国际航运中心研究院和海大展馆。
          </p>
          <p class="indentation">
            重庆交通大学学工部、航运与船舶工程学院、党政办、教务处、产学研处、党委宣传部，我校党委学生工作部、党委人才办公室、教务处、科技处、研究生院、发展规划与质量管理处等部门相关负责同志参加座谈。
            </p>
    
 <p class="indentation">
       <a href="https://news.dlmu.edu.cn/info/1021/78167.htm" target="_blank">以上内容摘自：重庆交通大学党委书记宫辉一行来校调研交流-大连海事大学新闻网 (dlmu.edu.cn)</a>
        </p>
      </div>
    </div>
  </div>
  </template>
  
  <script>
    export default {
      data() {
        return {
  
        };
      },
      methods: {
  
      },
    };
  
  </script>
  
  <style scoped>
    .fl {
      float: right;
      margin-right: 20px;
    }
  
    .fy {
      text-align: center;
      margin-top: 30px;
    }
  
    .title {
      height: 100%;
    }
  
    .div-width {
      width: 75%;
    }
  
  
  
    .div-line {
      background: #E6E6E6;
      height: 1px;
      width: 100%;
  
    }
  
    .div-bottom10 {
      padding-top: 10px;
    }
  
    .div-bottom30 {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  
    .div-top30 {
      padding-top: 30px;
    }
    img {
      vertical-align: middle;
      border-style: none;
      width: 95%; 
      border-radius: 10px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/contentcoms/news2024/news28.vue